var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dc-container" }, [
    _c("div", { staticClass: "dc-base" }, [
      _c("aside", [
        _c(
          "div",
          {
            ref: "sidebar",
            class: ["dp-sidebar", { affix: _vm.sidebarFixed }]
          },
          [
            _vm.isListingPage
              ? _c("h3", { staticClass: "b-title-section" }, [
                  _vm._v("Daily Challenges")
                ])
              : _vm.isDailyProblemDetail
              ? _c(
                  "router-link",
                  {
                    staticClass: "back-button",
                    attrs: { to: { name: "daily_problems_listing" } }
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "6",
                          height: "9",
                          viewBox: "0 0 6 9",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M0.664062 3.92188C0.537109 4.04883 0.537109 4.22656 0.664062 4.35352L4.39648 8.11133C4.49805 8.23828 4.70117 8.23828 4.82812 8.11133L5.31055 7.60352C5.4375 7.47656 5.4375 7.29883 5.31055 7.17188L2.31445 4.125L5.31055 1.10352C5.4375 0.976562 5.4375 0.773438 5.31055 0.671875L4.82812 0.164062C4.70117 0.0371094 4.49805 0.0371094 4.39648 0.164062L0.664062 3.92188Z",
                            fill: "#535353"
                          }
                        })
                      ]
                    ),
                    _vm._v("\n          Back\n        ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("DailyChallengeCalendar"),
            _vm._v(" "),
            _vm.showReminderBox ? _c("DailyChallengeReminder") : _vm._e(),
            _vm._v(" "),
            _vm.showFeaturedCourse
              ? _c("DailyChallengeFeaturedCourse")
              : _vm._e(),
            _vm._v(" "),
            _vm.enableAddToClassrooms
              ? _c("AddToClassrooms", { attrs: { classrooms: _vm.classrooms } })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "dp-main" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }